var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00902 19.0134C8.81089 19.0139 8.61707 18.9556 8.45213 18.8458C8.2872 18.7361 8.1586 18.5798 8.08264 18.3968C8.00668 18.2138 7.98679 18.0124 8.02549 17.818C8.06419 17.6237 8.15974 17.4453 8.30002 17.3054L13.6 12.0204L8.31902 6.72037C8.22624 6.6274 8.15268 6.51706 8.10255 6.39566C8.05241 6.27425 8.02668 6.14416 8.02681 6.01281C8.02695 5.88147 8.05296 5.75143 8.10336 5.63013C8.15375 5.50884 8.22754 5.39865 8.32052 5.30587C8.41349 5.2131 8.52383 5.13954 8.64524 5.0894C8.76664 5.03927 8.89673 5.01353 9.02808 5.01367C9.15943 5.01381 9.28946 5.03982 9.41076 5.09021C9.53206 5.14061 9.64224 5.2144 9.73502 5.30738L15.726 11.3164C15.9135 11.5039 16.0188 11.7582 16.0188 12.0234C16.0188 12.2885 15.9135 12.5428 15.726 12.7304L9.71502 18.7214C9.62241 18.8142 9.51236 18.8878 9.39119 18.9379C9.27002 18.988 9.14014 19.0137 9.00902 19.0134Z",
    fill: "#393A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.d578649cefc8bb36aefc948210de81bb.svg";
export { ForwardRef as ReactComponent };